import { GarageCustomizationData, UnitDetails } from "./garageCustomization.interface";

export const initialState: GarageCustomizationData = {
  customizedGarage: {},
  CustomizedShutter:{},
  parkingProducts: {
    products: {
      "Roller Shutter Paint": [],
      Flooring: [],
      "Left Wall Add-on": [],
      Lighting: [],
    },
    parkingtype: "",
    parkingtier: "",
    parkingSegment: "",
    parkingRefId: 0,
    parkingId: "",
    parkingGroup: "",
    parkingCategory: "",
    listPrice: ""
  },
  parkingReferenceId:"",
  savedQuoteData:{},
  selectedQuote: {
    id: "",
    quoteLineItems: []
  },  
  defaultQuoteSelected:{},
  parkingPaymentDetails: {
    totalPaid: 0,
    receiptNumber: ''
  },
  eligibleProperties: [] as any,
  leadOpportunityId:""
};
